export const BookingStep = {
  TIME: 0,
  PARTICIPANTS: 1,
  PAYMENT: 2,
  SUMMARY: 3,
};
